import { render } from "./B2bPageDeliveryNotesEmits.vue?vue&type=template&id=2635fcc0&scoped=true&lang=pug"
import script from "./B2bPageDeliveryNotesEmits.vue?vue&type=script&lang=js"
export * from "./B2bPageDeliveryNotesEmits.vue?vue&type=script&lang=js"

import "./B2bPageDeliveryNotesEmits.vue?vue&type=style&index=0&id=2635fcc0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2635fcc0"]])

export default __exports__